import { render, staticRenderFns } from "./dialogue.vue?vue&type=template&id=52acb99c&scoped=true"
import script from "./dialogue.vue?vue&type=script&lang=js"
export * from "./dialogue.vue?vue&type=script&lang=js"
import style0 from "./dialogue.vue?vue&type=style&index=0&id=52acb99c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52acb99c",
  null
  
)

export default component.exports